import request from '@/utils/request2';
export function typeList(data) {
  return request.post('admin/company-organization/list', data);
}
export function typeStatus(data) {
  return request.post('admin/company-organization/status', data);
}
export function typeDelete(data) {
  return request.post('admin/company-organization/delete', data);
}
export function addType(data) {
  return request.post('admin/company-organization/store', data);
}
export function editType(data) {
  return request.post('admin/company-organization/edit', data);
}